import { createFormHook } from '@tanstack/react-form';

import { fieldContext, formContext } from '@/library/form/contexts';
import { appFieldComponents, appFormComponents } from '@/library/form/fieldComponents';

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldComponents: appFieldComponents,
  formComponents: appFormComponents,
  fieldContext,
  formContext,
});
